import React, { Children } from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Scale, Leaf } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 bg-cream relative" data-id="element-140">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141">
        <FadeIn data-id="element-142">
          <div className="text-center mb-20" data-id="element-143">
            <h2 className="text-4xl md:text-5xl font-serif text-brown mb-6" data-id="element-144">
              Reconecta con tu energía femenina
            </h2>
            <p className="text-xl text-brown/70 max-w-3xl mx-auto leading-relaxed" data-id="element-145">
              Esto no es solo un ebook. Es un sistema integral de 3 partes
              diseñado para desmantelar tu armadura y devolverte a tu centro.
            </p>
          </div>
        </FadeIn>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-146">
          {/* Card 1 */}
          <motion.div variants={itemVariants} className="bg-white p-8 md:p-10 rounded-3xl shadow-xl shadow-brown/5 border border-gold/10 flex flex-col h-full" data-id="element-147">
            <div className="w-14 h-14 bg-cream rounded-full flex items-center justify-center mb-8" data-id="element-148">
              <BookOpen className="w-7 h-7 text-gold-dark" data-id="element-149" />
            </div>
            <h3 className="text-2xl font-serif text-brown font-bold mb-6" data-id="element-150">
              1. Ebook Transformador
            </h3>
            <ul className="space-y-4 text-brown/70 flex-1" data-id="element-151">
              <li className="flex items-start" data-id="element-152">
                <span className="text-gold mr-2" data-id="element-153">•</span> Te enseña lo que te
                está pasando
              </li>
              <li className="flex items-start" data-id="element-154">
                <span className="text-gold mr-2" data-id="element-155">•</span> Te ayuda a
                identificarte
              </li>
              <li className="flex items-start" data-id="element-156">
                <span className="text-gold mr-2" data-id="element-157">•</span> Incluye ejercicios
                prácticos
              </li>
              <li className="flex items-start" data-id="element-158">
                <span className="text-gold mr-2" data-id="element-159">•</span> No es teoría, es
                aplicación
              </li>
            </ul>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={itemVariants} className="bg-white p-8 md:p-10 rounded-3xl shadow-xl shadow-brown/5 border border-gold/10 flex flex-col h-full relative overflow-hidden" data-id="element-160">
            <div className="absolute top-0 right-0 w-32 h-32 bg-rose-light/10 rounded-bl-full" data-id="element-161" />
            <div className="relative z-10" data-id="element-162">
              <div className="w-14 h-14 bg-cream rounded-full flex items-center justify-center mb-8" data-id="element-163">
                <Scale className="w-7 h-7 text-gold-dark" data-id="element-164" />
              </div>
              <h3 className="text-2xl font-serif text-brown font-bold mb-4" data-id="element-165">
                2. App Ecos de Polaridad
              </h3>
              <p className="text-brown/70 mb-6 text-sm" data-id="element-166">
                Es una app que contiene un test de polaridad y un mapa de estrés
                corporal.
              </p>
              <ul className="space-y-4 text-brown/70 mb-8" data-id="element-167">
                <li className="flex items-start" data-id="element-168">
                  <span className="text-gold mr-2" data-id="element-169">•</span> Te muestra desde qué
                  energía estás operando
                </li>
                <li className="flex items-start" data-id="element-170">
                  <span className="text-gold mr-2" data-id="element-171">•</span> Identifica si estás
                  en control constante
                </li>
                <li className="flex items-start" data-id="element-172">
                  <span className="text-gold mr-2" data-id="element-173">•</span> Te muestra dónde tu
                  cuerpo está cargando tensión
                </li>
              </ul>
              <div className="mt-auto pt-6 border-t border-gold/20" data-id="element-174">
                <p className="font-serif italic text-brown-light font-bold" data-id="element-175">
                  "Tu cuerpo está sosteniendo lo que tu mente no ha soltado"
                </p>
              </div>
            </div>
          </motion.div>

          {/* Card 3 */}
          <motion.div variants={itemVariants} className="bg-white p-8 md:p-10 rounded-3xl shadow-xl shadow-brown/5 border border-gold/10 flex flex-col h-full" data-id="element-176">
            <div className="w-14 h-14 bg-cream rounded-full flex items-center justify-center mb-8" data-id="element-177">
              <Leaf className="w-7 h-7 text-gold-dark" data-id="element-178" />
            </div>
            <h3 className="text-2xl font-serif text-brown font-bold mb-6" data-id="element-179">
              3. App Alma
            </h3>
            <ul className="space-y-4 text-brown/70 flex-1" data-id="element-180">
              <li className="flex items-start" data-id="element-181">
                <span className="text-gold mr-2" data-id="element-182">•</span> App para uso diario
              </li>
              <li className="flex items-start" data-id="element-183">
                <span className="text-gold mr-2" data-id="element-184">•</span> Te guía con
                respiración y presencia
              </li>
              <li className="flex items-start" data-id="element-185">
                <span className="text-gold mr-2" data-id="element-186">•</span> Te pregunta cómo estás
              </li>
              <li className="flex items-start" data-id="element-187">
                <span className="text-gold mr-2" data-id="element-188">•</span> Tu respuesta es
                analizada según niveles de conciencia del Dr. David Hawkins
              </li>
              <li className="flex items-start" data-id="element-189">
                <span className="text-gold mr-2" data-id="element-190">•</span> Detecta si estás en
                nivel bajo de conciencia
              </li>
            </ul>
            <div className="mt-6 p-4 bg-cream/50 rounded-xl border border-gold/20" data-id="element-191">
              <p className="text-sm text-brown font-bold" data-id="element-192">
                Te entrega 3 acciones prácticas para salir de ese estado
                inmediatamente.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}